module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SSN1oD/images/cover.jpeg?1718044968786",
      "alt": "This image is the cover for the book The Deviant #1, The Deviant"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Deviant #1, The Deviant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("SERIES PREMIERE As snow falls over Milwaukee in 1972, a blood-stained Santa Claus commits unimaginable atrocities against young men. Fifty years later, a troubled young writer interviews this so-called \"Deviant Killer,\" who still maintains his innocence from behind bars. And as Christmas approaches once again, the past returns, wielding a sharpened ax. Eisner-winning writer JAMES TYNION IV (W0RLDTR33, THE DEPARTMENT OF TRUTH) and acclaimed artist JOSHUA HIXSON (The Plot, Children of the Woods) unite for a pitch-black holiday horror story.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Tynion IV, Joshua Hixson, Joshua Hixson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Image Comics\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0